export default __webpack_public_path__ + "static/media/all.cc10489a.svg";